import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

// 3rd party imports
import swal from "sweetalert2";
import{ without, map} from "underscore";
import { MESSAGECONSTANTS } from '@app/constants/constant-messages';
@Injectable()
export class CommonAlertsService {
  constructor(public translate: TranslateService) { }
  fileSizeShouldNotMT20MB() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.FILE_SIZE_SHOULD_NOT_BE_MORE_THAN_20MB), text: '', type: 'warning', cancelButtonText: '', confirmButtonText: this.translate.instant('OK'), allowOutsideClick: true, showCancelButton: false }); }
  fileExtensionAlert() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.FILE_SHOULD_BE_JPG_JPEG_PNG_EXTENTION), text: '', type: 'warning', cancelButtonText: '', confirmButtonText: this.translate.instant('OK'), allowOutsideClick: true, showCancelButton: false }); }
  campaignExpiredAlert() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.CAMPAIGN_EXPIRED) + '.', text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_CONTACT_ADMIN_FOR_MORE_CAMPAIGNS) + '.', type: 'warning', allowOutsideClick: true, showCancelButton: false, confirmButtonText: this.translate.instant('OK'), cancelButtonText: '' }); }
  agentsNotFree() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.NO_FIELDS_AGENT_FREE_MISSION_START_DATE), text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_ASK_ADMIN_TO_ADD_FIELDS_AGENT), type: 'warning', cancelButtonText: '', confirmButtonText: this.translate.instant('OK'), allowOutsideClick: false, showCancelButton: false }); }
  googleGeocoderError() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.GOOGLE_GEOCODING_ERROR), text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.DAILY_LIMIT_FOR_TODAY_REACHED_FOR_SEARCHING_LOCATION), type: 'warning', cancelButtonText: '', confirmButtonText: this.translate.instant('OK'), allowOutsideClick: true, showCancelButton: false }); }
  alreadyFieldAgentsusedAssignment() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.FIELD_AGENT_USED_IN_ASSIGNMENT), text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_SELECT_ANOTHER_FIELD_AGENT), type: 'warning', cancelButtonText: '', confirmButtonText: this.translate.instant('OK'), allowOutsideClick: false, showCancelButton: false }); }
  selectCampagin() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_SELECT_CAMPAIGN), type: 'warning', cancelButtonText: '', confirmButtonText: this.translate.instant('Ok'), allowOutsideClick: false, showCancelButton: false }); }
  missionCreatedSuccessPOSAlert() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.MISSION_CREATED_SUCCESSFULLY), text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_SELECT_QUARTIER_FOR_MISSION), type: 'success', cancelButtonText: '', confirmButtonText: this.translate.instant('OK'), allowOutsideClick: false, showCancelButton: false }); }
  quartierAssignSuccessAlert() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.QUARTIER_ASSIGNED_SUCCESSFULLY), text: '', type: 'success', cancelButtonText: '', confirmButtonText: this.translate.instant('OK'), allowOutsideClick: false, showCancelButton: false }); }
  somethingWentWrong() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.SOMETHING_WENT_WRONG), text: '', type: 'warning', cancelButtonText: '', confirmButtonText: this.translate.instant('OK'), allowOutsideClick: false, showCancelButton: false }); }
  somethingWentWrongQuestion() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.SOMETHING_WENT_WRONG), text: '', type: 'question', cancelButtonText: '', confirmButtonText: this.translate.instant('OK'), allowOutsideClick: false, showCancelButton: false }); }
  assignmentSuccessAlert() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.ASSIGNMENT_COMPLETED_SUCCESSFULLY), text: '', type: 'success', cancelButtonText: '', confirmButtonText: this.translate.instant('OK'), allowOutsideClick: false, showCancelButton: false }); }
  assignmentWaringAlert() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.SOMETHING_WENT_WRONG), text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.SOMETHING_WENT_WRONG_OR_MORE_ASSIGNMENTS_NOT_SUCCESSFULLY_CREATED), type: 'warning', cancelButtonText: '', confirmButtonText: this.translate.instant('OK'), allowOutsideClick: false, showCancelButton: false }); }
  postCodeNotAvailableAlert() {
    return swal({
      title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.POSTAL_CODE_NOT_AVAILABLE),
      text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_SELECT_OTHER_OPTION),
      type: 'warning',
      cancelButtonText: '',
      confirmButtonText: this.translate.instant('OK'),
      allowOutsideClick: false,
      showCancelButton: false
    });
  }
  streetsNotAvailableAlert() {
    return swal({
      title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.STREETS_NOT_AVAILABLE),
      text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_SELECT_OTHER_OPTION),
      type: 'warning',
      cancelButtonText: '',
      confirmButtonText: this.translate.instant('OK'),
      allowOutsideClick: false,
      showCancelButton: false
    });
  }
  adrnNotAvailableAlert() {
    return swal({
      title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.ADRN_NOT_AVAILABLE),
      text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_SELECT_OTHER_OPTION),
      type: 'warning',
      cancelButtonText: '',
      confirmButtonText: this.translate.instant('OK'),
      allowOutsideClick: false,
      showCancelButton: false
    });
  }
  adptidNotAvailable() {
    return swal({
      title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.ADPTID_NOT_AVAILABLE),
      text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_SELECT_OTHER_OPTION),
      type: 'warning',
      cancelButtonText: '',
      confirmButtonText: this.translate.instant('OK'),
      allowOutsideClick: false,
      showCancelButton: false
    });
  }
  dateMandatoryAlert() {
    return swal({
      title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.DATE_MISSION_FIELDS_MANDATORY),
      text: '',
      type: 'warning',
      cancelButtonText: '',
      confirmButtonText: this.translate.instant('OK'),
      allowOutsideClick: false,
      showCancelButton: false
    });
  }
  sameShiftCanNotAssigned() {
    return swal({
      title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.SAME_SHIFT_CANNOT_BE_ASSIGNED),
      text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_SELECT_ANOTHER_SHIFT),
      type: 'error',
      cancelButtonText: '',
      confirmButtonText: this.translate.instant('OK'),
      allowOutsideClick: false,
      showCancelButton: false
    });
  }
  sameShiftIteration() {
    return swal({
      title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.CANNOT_ASSIGN_SHIFT_TIMING_WITH_SAME_ITERATION_COUNT),
      text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_SELECT_ANOTHER_SHIFT),
      type: 'error',
      cancelButtonText: '',
      confirmButtonText: this.translate.instant('OK'),
      allowOutsideClick: false,
      showCancelButton: false
    });
  }
  uniqueApdtId() {
    return swal({
      title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_ENTER_VALID_ADPTID),
      text: '',
      type: 'warning',
      allowOutsideClick: true,
      cancelButtonText: '',
      showCancelButton: false,
      confirmButtonText: this.translate.instant('Ok')
    });
  }
  warningAlert(errorMessage) {
    return swal({
      title: '',
      text: '',
      html: this.splitAndAddBr(errorMessage),
      type: 'warning',
      cancelButtonText: '',
      confirmButtonText: this.translate.instant('OK'),
      allowOutsideClick: true,
      showCancelButton: false
    });
  }
  splitAndAddBr(message) {
    let valArray = without(message.split('</br>'), "");
    return map(valArray, (i) => { return this.translate.instant(i) }).join('</br>');
  }
  conditionBeforeSubmit(message) {
    return swal({
      title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_CHECK_THESE_CONDITIONS_B4_SUBMITTING),
      text: '',
      html: this.splitAndAddBr(message),
      type: 'warning',
      cancelButtonText: '',
      confirmButtonText: this.translate.instant('OK'),
      allowOutsideClick: false,
      showCancelButton: false
    });
  }
  changingDateRemoveAssignments() {
    return swal({
      title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.CHANGING_MISSION_DATE_WILL_REMOVE_ALL_ASSIGNMENTS) + ".",
      text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.ARE_YOU_SURE_TO_CHANGE_MISSION_DATE) + "?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.YES_CHANGE_IT) + '!',
      cancelButtonText: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.NO_CANCEL),
      allowOutsideClick: false
    });
  }
  googleDailylimitAlert() {
    return swal(this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.GOOGLE_GEOCODING_ERROR), this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.TODAYS_DAILY_LIMIT_REACHED_FOR_SEARCHING_A_LOCATION), 'warning');
  }
  inCaseChangesDeleted() {
    return swal({
      title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.YOU_CHANGE_THIS_THE_DATA_WILL_BE_DELETED) + '.',
      text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_CONFIRM) + '.',
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.YES_I_WILL_CHANGE_IT) + '.'
    });
  }
  dateMoreThanTodayAlert() {
    return swal(this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.CHANGE_THE_MISSION_DATE) +
            '.', this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.IT_SHOULD_BE_MORE_THAN_TODAY) + '.', 'warning');
  }
  searchMapImage(circuitMessages) {
    return swal(this.translate.instant(circuitMessages), this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_CHECK_IF_LOCATION_SEARCHED_fROM_MAP_AS_WELL_as_IMAGE_IS_ADDED) + '.', 'warning');
  }
  allFieldsMandatory() {
    return swal(this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.ALL_FIELDS_MANDATORY_IN_MISSION_FORM) + '.', '', 'warning');
  }
  doYouWantContinue(title) {
    return swal({
      title: this.translate.instant(title),
      text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.DO_YOU_WANT_TO_CONTINUE) + '.',
      type: 'warning',
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.YES_DELETE_IT) + '!',
      cancelButtonText: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.NO_CANCEL) + '!',
    });
  }
  missionUpdateSuccess() {
    return swal(this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.MISSION_UDPATED_SUCCESSFULLY), '', 'success');
  }
  /**ISSUE 920 */
  enterValidLocation() { return swal({ title: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.INVALID_LOCATION), text: this.translate.instant(MESSAGECONSTANTS.ALERT_MESSAGES.PLEASE_ENTER_VALID_LOCATION), type: 'warning', cancelButtonText: '', confirmButtonText: this.translate.instant('OK'), allowOutsideClick: true, showCancelButton: false });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src185846418/src/src/app/services/Alerts/common-alerts.service.ts